import React from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import {
  activateSchedule,
  deactivateSchedule,
  getScheduleActiveStatus,
} from "reduxSlices/reportIndexSlice"
import Switch from "shared/Switch"

const ScheduleActive = ({ reportType, scheduleId }) => {
  const dispatch = useDispatch()

  const scheduleIsActive = useSelector(getScheduleActiveStatus(reportType, scheduleId))

  const toggleScheduleActiveStatus = () => {
    const thunk = scheduleIsActive ? deactivateSchedule : activateSchedule

    dispatch(thunk({ reportType, scheduleId }))
  }

  return (
    <Switch
      aria-label="SFTP uploads active"
      checked={scheduleIsActive}
      onChange={toggleScheduleActiveStatus}
    />
  )
}

ScheduleActive.propTypes = {
  reportType: types.string.isRequired,
  scheduleId: types.number.isRequired,
}

export default ScheduleActive
